import {onClick,onClickDynamic} from '../abstract/helpers.js';

export class ResponsiveMenu {
  constructor() {

    this.scrollPosition = 0;

    if(document.getElementsByClassName('resp-menu-selector').length > 0) {
      onClick(document.getElementsByClassName('resp-menu-selector')[0], function () {
        document.body.classList.toggle("resp-menu-open");

        if (document.body.classList.contains('resp-menu-open')) {
          document.body.classList.add("resp-menu-open");
          this.lockViewportScroll();
        } else {
          document.body.classList.remove("resp-menu-open");
          this.unlockViewportScroll();
        }
      }.bind(this));

     
      onClickDynamic('.resp-menu-open .header-navigation-mobile nav > ul > li:not(.mobile-main) > span', function (e) {
        e.preventDefault();
        e.target.parentNode.classList.add('open-mobile-stage-1');
        //this.slideToggle(e.target.nextElementSibling);
      }.bind(this));

     
      onClickDynamic('.resp-menu-open .header-navigation-mobile nav > ul > li:not(.mobile-main) > span > svg', function (e) {
        e.preventDefault();

        e.target.parentNode.parentNode.classList.add('open-mobile-stage-1');
        //this.slideToggle(e.target.parentNode.nextElementSibling);
      }.bind(this));
     

      onClickDynamic('.header-navigation-mobile > nav > ul > li .dropdown-navigation-mobile > span.title', function (e) {
        e.preventDefault();

        e.target.parentNode.parentNode.classList.remove('open-mobile-stage-1');
        //this.slideToggle(e.target.parentNode.nextElementSibling);
      }.bind(this));

      onClickDynamic('.header-navigation-mobile > nav > ul > li .dropdown-navigation-mobile .has-dropdown', function (e) {
        e.preventDefault();
        e.target.parentNode.classList.toggle('open-mobile-stage-2');
        this.slideToggle(e.target.nextElementSibling);
      }.bind(this));

      onClickDynamic('.header-navigation-mobile > nav > ul > li .dropdown-navigation-mobile .has-dropdown > span,.header-navigation-mobile > nav > ul > li .dropdown-navigation-mobile .has-dropdown > svg', function (e) {
        e.preventDefault();
        e.target.parentNode.parentNode.classList.toggle('open-mobile-stage-2');
        this.slideToggle(e.target.parentNode.nextElementSibling);
      }.bind(this));

      


      onClickDynamic('.menu-style-1-title, .menu-style-1-title *', function (e) {
        e.preventDefault();
        
        if(e.target.classList.contains('menu-style-1-title'))  {

          if(e.target.classList.contains('open')) {
            e.target.classList.remove('open');
            this.slideUp(e.target.nextElementSibling);
          } else {
            e.target.classList.add('open');
            this.slideDown(e.target.nextElementSibling);
          }

        }else {
          let f = e.target.closest('.menu-style-1-title');

          if(f.classList.contains('open')) {
            f.classList.remove('open');
            this.slideUp(f.nextElementSibling);
          } else {
            f.classList.add('open');
            this.slideDown(f.nextElementSibling);
          }
        }

      }.bind(this));


      onClickDynamic('.filter-form .filter-head, .filter-form .filter-head *', function (e) {
        e.preventDefault();
        
        
        if(e.target.classList.contains('filter-head'))  {

          if(e.target.classList.contains('open')) {
            e.target.classList.remove('open');
            this.slideUp(e.target.nextElementSibling);
          } else {
            e.target.classList.add('open');
            this.slideDown(e.target.nextElementSibling);
          }

        }else {

          let f = e.target.closest('.filter-head');

          if(f.classList.contains('open')) {
            f.classList.remove('open');
            this.slideUp(f.nextElementSibling);
          } else {
            f.classList.add('open');
            this.slideDown(f.nextElementSibling);
          }

        }

      }.bind(this));


      
      let windowWidth = window.innerWidth;
      addEventListener("resize", (event) => {});
      onresize = (event) => {
        const newWindowWidth = window.innerWidth;
        if (newWindowWidth !== windowWidth) {
          document.querySelectorAll('.filter-form .filter-head,.filter-form .filter-body, .menu-style-1,.menu-style-1-title,.dropdown-navigation-detailed,.dropdown-navigation,.header-navigation-mobile nav > ul > li').forEach(function(el) {
            //el.removeAttribute("style");
            //el.classList.remove('open');
            //document.body.classList.remove("resp-menu-open");
            //this.unlockViewportScroll();

            
            
              const isHorizontalResize = newWindowWidth < windowWidth;
              if (isHorizontalResize) {
                el.removeAttribute("style");
              }

              
            
          }.bind(this));

          document.querySelector('body').removeAttribute("style");
          document.querySelector('body').classList.remove("resp-menu-open");

        }

        windowWidth = newWindowWidth;
      };

    }
  }

  lockViewportScroll() {
    // Store the current scroll position
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    let body = document.querySelector('body');
    // Add styles to body element to prevent scrolling
    body.style.position = 'fixed';
    body.style.top = `-${this.scrollPosition}px`;
    body.style.overflowY = 'scroll';
    body.style.width = '100%';
  }

  unlockViewportScroll() {
    // Remove styles from body element to enable scrolling
    let body = document.querySelector('body');
    body.style.position = '';
    body.style.top = '';
    body.style.overflowY = '';
    body.style.width = '';
  
    // Restore the previous scroll position
    window.scrollTo(0, this.scrollPosition);
  }

  slideUp = (target, duration=500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      //alert("!");
    }, duration);
  }

  slideDown = (target, duration=500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
      display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
      target.parentNode.classList.add('open');
      return this.slideDown(target, duration);
    } else {
      target.parentNode.classList.remove('open');
      return this.slideUp(target, duration);
    }
  }

}
